import { ISteps } from "shared/types";

export const dataStep: ISteps[] = [
  {
    icon: 1,
    title: "Plano",
    subtitle: "Qual o seu plano?",
    active: 1,
  },
  {
    icon: 2,
    title: "Local",
    subtitle: "Cidade para ser atendido",
    active: 2,
  },
  {
    icon: 3,
    title: "Especialidade",
    subtitle: "Qual o atendimento?",
    active: 3,
  },

  {
    icon: 4,
    title: "Rede Credenciada",
    subtitle: "Médicos disponíveis",
    active: 4,
  },
];
